/* eslint-disable react/no-unescaped-entities */
import { useState } from "react";
import {
  Accordion,
  AccordionHeader,
  AccordionBody,
} from "@material-tailwind/react";

function Icon({ id, open }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={`${
        id === open ? "rotate-180" : ""
      } h-5 w-5 transition-transform`}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
    </svg>
  );
}

const FaqAccordion = () => {
  const [open, setOpen] = useState(1);

  const handleOpen = (value) => {
    setOpen(open === value ? 0 : value);
  };

  return (
    <div className="mb-14 dark:bg">
      <Accordion
        className="mb-5 overflow-hidden rounded-lg border border-jacarta-200 dark:border-jacarta-200"
        open={open === 1}
        icon={<Icon id={1} open={open} />}
      >
        <AccordionHeader
          className="accordion-button relative flex w-full items-center justify-between px-4 py-3 text-left font-display dark:bg-jacarta-900 bg-jacarta-900 dark:text-white text-white text-md"
          onClick={() => handleOpen(1)}
        >
          Ingresa tu DNI
        </AccordionHeader>
        <AccordionBody className="accordion-body border-t border-jacarta-200 p-4 dark:border-jacarta-200 dark:bg-jacarta-900 bg-jacarta-900 h-full dark:text-jacarta-200 text-jacarta-200">
        Ingresa tu documento de identidad para que esté asociado a los beneficios que brinda IRBin.
        </AccordionBody>
      </Accordion>
      <Accordion
        className="mb-5 overflow-hidden rounded-lg border border-jacarta-200 dark:border-jacarta-200"
        open={open === 2}
        icon={<Icon id={2} open={open} />}
      >
        <AccordionHeader
          className="accordion-button relative flex w-full items-center justify-between px-4 py-3 text-left font-display dark:bg-jacarta-900 bg-jacarta-900 dark:text-white text-white text-md"
          onClick={() => handleOpen(2)}
        >
          Deposita tu residuo
        </AccordionHeader>
        <AccordionBody className="accordion-body border-t border-jacarta-200 p-4 dark:border-jacarta-200 dark:bg-jacarta-900 bg-jacarta-900 h-full dark:text-jacarta-200 text-jacarta-200">
        Ingresa tu residuo para que sea identificado, si tienes más residuos colócalos uno por uno.
        </AccordionBody>
      </Accordion>
      <Accordion
        className="mb-5 overflow-hidden rounded-lg border border-jacarta-200 dark:border-jacarta-200"
        open={open === 3}
        icon={<Icon id={3} open={open} />}
      >
        <AccordionHeader
          className="accordion-button relative flex w-full items-center justify-between px-4 py-3 text-left font-display dark:bg-jacarta-900 bg-jacarta-900 dark:text-white text-white text-md"
          onClick={() => handleOpen(3)}
        >
          Canjea por beneficios
        </AccordionHeader>
        <AccordionBody className="accordion-body border-t border-jacarta-200 p-4 dark:border-jacarta-200 dark:bg-jacarta-900 bg-jacarta-900 h-full dark:text-jacarta-200 text-jacarta-200">
          Obtén beneficios por interactuar con IRBin al finalizar.
        </AccordionBody>
      </Accordion>
    </div>
  );
};

export default FaqAccordion;
